import { cn } from '@/utils/cn'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  error?: string
}

export function Input({ label, error, id, className, ...props }: InputProps) {
  const errorId = error && id ? `${id}-error` : undefined

  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="text-xs uppercase tracking-widest text-label font-light"
      >
        {label}
      </label>
      <input
        id={id}
        aria-describedby={errorId}
        aria-invalid={error ? true : undefined}
        className={cn(
          'w-full min-h-11 rounded-md border border-border-divider bg-surface-bg px-4 py-3 text-base sm:text-sm text-body font-light',
          'placeholder:text-label/60',
          'focus-visible:outline-none focus-visible:border-accent focus-visible:ring-2 focus-visible:ring-accent/30',
          'transition-colors duration-200',
          error && 'border-error-border focus-visible:border-error focus-visible:ring-error-ring',
          className,
        )}
        {...props}
      />
      {error && (
        <p id={errorId} role="alert" className="text-xs text-error font-light">
          {error}
        </p>
      )}
    </div>
  )
}
